export function preventNavigation() {
    // Warn user on refresh (F5 or Ctrl+R)
    const handleBeforeUnload = (event) => {
        // Do not show alert when the user is navigated in the login page, or welcome screen that typically do not have
        // any hash parameter.
        // Display alert when a user is navigated somewhere inside the app, like /#/users/registrations
        if (location.hash.length < 2) {
            return;
        }
        // modern browsers do not allow customizing the message anymore;
        // calling preventDefault and setting returnValue triggers the native confirmation dialog
        event.preventDefault();
        event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
}
